import { EnhancementItems } from './enhancementItems';

export class AllEnhancement {
    // private enhancementItems: EnhancementItems[];
    private categoryType: string;
    private categoryTypeStr: string;
    private tempString: string;
    private startDate: Date;
    private endDate: Date;
    private roomType: String;
    private claimedAmount: number;
    private enhancementRequested: number;
    private finalAmount: number;
    private packageName:string;
    private roomCategory:string;
    private units:number;

    constructor(allEnhamcement: any) {
        this.tempString = allEnhamcement.tempString;
        this.units =allEnhamcement.units;
        this.categoryType = allEnhamcement.categoryType;
        this.categoryTypeStr = allEnhamcement.categoryTypeStr;
        this.startDate = allEnhamcement.startDate;
        this.endDate = allEnhamcement.endDate;
        this.roomType = allEnhamcement.roomType;
        this.claimedAmount = allEnhamcement.claimedAmount;
        this.enhancementRequested = allEnhamcement.enhancementRequested;
        this.finalAmount = allEnhamcement.finalAmount;
        this.packageName=allEnhamcement.packageName;
        this.roomCategory=allEnhamcement.roomCategory;
        // if (allEnhamcement.enhancementItems) {
        //     this.enhancementItems = [];
        //     for (const doc of allEnhamcement.enhancementItems) {
        //         if (doc) {
        //             this.enhancementItems.push(new EnhancementItems(doc));
        //         }
        //     }
        // } else {
        //     this.enhancementItems = [];
        // }
    }
 /**
     * Getter $packageName
     * @return {string}
     */
    public get $packageName(): string {
        return this.packageName;
    }

    /**
     * Setter $packageName
     * @param {string} value
     */
    public set $packageName(value: string) {
        this.packageName = value;
    }
    /**
     * Getter $tempString
     * @return {string}
     */
    public get $tempString(): string {
        return this.tempString;
    }
     /**
     * Setter $units
     * @param {number} value
     */
    public set $units(value: number) {
        this.units = value;
    }
    /**
     * Getter $units
     * @return {number}
     */
    public get $units(): number {
        return this.units;
    }
    /**
     * Setter $roomCategory
     * @param {string} value
     */
    public set $roomCategory(value: string) {
        this.roomCategory = value;
    }
    /**
     * Getter $roomCategory
     * @return {string}
     */
    public get $roomCategory(): string {
        return this.roomCategory;
    }
    /**
     * Setter $tempString
     * @param {string} value
     */
    public set $tempString(value: string) {
        this.tempString = value;
    }

    /**
     * Getter $startDate
     * @return {Date}
     */
    public get $startDate(): Date {
        return this.startDate;
    }

    /**
     * Getter $endDate
     * @return {Date}
     */
    public get $endDate(): Date {
        return this.endDate;
    }

    /**
     * Getter $roomType
     * @return {String}
     */
    public get $roomType(): String {
        return this.roomType;
    }

    /**
     * Getter $claimedAmount
     * @return {number}
     */
    public get $claimedAmount(): number {
        return this.claimedAmount;
    }

    /**
     * Getter $enhancementRequested
     * @return {number}
     */
    public get $enhancementRequested(): number {
        return this.enhancementRequested;
    }

    /**
     * Getter $finalAmount
     * @return {number}
     */
    public get $finalAmount(): number {
        return this.finalAmount;
    }

    /**
     * Setter $startDate
     * @param {Date} value
     */
    public set $startDate(value: Date) {
        this.startDate = value;
    }

    /**
     * Setter $endDate
     * @param {Date} value
     */
    public set $endDate(value: Date) {
        this.endDate = value;
    }

    /**
     * Setter $roomType
     * @param {String} value
     */
    public set $roomType(value: String) {
        this.roomType = value;
    }

    /**
     * Setter $claimedAmount
     * @param {number} value
     */
    public set $claimedAmount(value: number) {
        this.claimedAmount = value;
    }

    /**
     * Setter $enhancementRequested
     * @param {number} value
     */
    public set $enhancementRequested(value: number) {
        this.enhancementRequested = value;
    }

    /**
     * Setter $finalAmount
     * @param {number} value
     */
    public set $finalAmount(value: number) {
        this.finalAmount = value;
    }

    // /**
    //  * Getter $enhancementItems
    //  * @return {EnhancementItems[]}
    //  */
    // public get $enhancementItems(): EnhancementItems[] {
    //     return this.enhancementItems;
    // }

    /**
     * Getter $categoryType
     * @return {string}
     */
    public get $categoryType(): string {
        return this.categoryType;
    }

    /**
     * Getter $categoryTypeStr
     * @return {string}
     */
    public get $categoryTypeStr(): string {
        return this.categoryTypeStr;
    }

    // /**
    //  * Setter $enhancementItems
    //  * @param {EnhancementItems[]} value
    //  */
    // public set $enhancementItems(value: EnhancementItems[]) {
    //     this.enhancementItems = value;
    // }

    /**
     * Setter $categoryType
     * @param {string} value
     */
    public set $categoryType(value: string) {
        this.categoryType = value;
    }

    /**
     * Setter $categoryTypeStr
     * @param {string} value
     */
    public set $categoryTypeStr(value: string) {
        this.categoryTypeStr = value;
    }

}
